import { add, remove } from "lodash";
import { handleChange } from "./form/functions";

$(document).on('click', '.fancy-select:not(.fancy-radio) .option .inner', function(event){
    // Get the hidden field
    var target = $(event.currentTarget);
    var select = target.closest('.fancy-select');
    var option = target.closest('.option');
    if (option.is('.active')) {
        return false;
    }
    var field = select.closest('.form-group').find('input[type=hidden]');
    option.toggleClass('active');
    field.val(option.data('value')).change();
});

$(document).on('click', '.fancy-radio .option .inner', function(event){
    // Get the hidden field
    let target = $(event.currentTarget);
    let select = target.closest('.fancy-radio');
    let option = target.closest('.option');
    let field = select.closest('.form-group').find('input[type=hidden]');
    option.toggleClass('active');
    let enabledOptions = select.find('.option.active').map(function(i, o) {
        return $(o).data('value');
    }).toArray() || [];
    field.val(enabledOptions.join(',')).change();
});

handleChange('.fancy-select-hidden', (event, value, target) => {
    // Update the UI if the back is changed
    let formGroup = target.closest('.form-group');
    let buttons = formGroup.find('.fancy-select .option');
    let selected = formGroup.find('.fancy-select .option.active');
    selected.removeClass('active');
    buttons.find('.active-radio').css('display','none');
    if (value == '') {
        return;
    }
    // Make the change if the new value matches a button
    let targetButton = buttons.filter('[data-value=' + value + ']');
    if (targetButton.length === 1) {
        targetButton.addClass('active');
        targetButton.find('.active-radio').css('display','block');
    } else {
        target.val('');
    }
});